import { DetailComponent } from './detail/detail.component';
import { SummaryComponent } from './summary/summary.component';

export const ResultChildRoutes = [
  {
    path: 'detail/:ofuscatedData',
    component: DetailComponent,
  },
  {
    path: '',
    component: SummaryComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/license/show-deleted',
  },
];
